function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, JSON, Object, String, error, focused, from, isRangePicker, to) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const isFixedRange = $helpers.isFixedRange();
    return {
      value: (h("div", {
        "class": {
          'calendar-input': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'date-inputs': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-date-input", {
            "attrs": __vjadeStringifyAttrsIfObj({
              error: !!error.from,
              value: from,
            }),
            "on": {
              blur: $helpers.blurredFrom,
              change: isFixedRange ? $helpers.changedFixedRangeFrom : $helpers.changedFrom,
              focus: $helpers.focusedFrom,
              mouseenter: $helpers.mouseenterFrom,
              mouseleave: $helpers.mouseleaveFrom,
            },
            "class": Object.assign({}, {
              'focused': focused === `from`
            }, {
              'from-date-input': true
            }),
          }));
          __jade_nodes = __jade_nodes.concat((isRangePicker) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'preposition': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("and");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("mp-date-input", {
              "attrs": __vjadeStringifyAttrsIfObj({
                error: !!error.to,
                value: to,
              }),
              "on": {
                blur: $helpers.blurredTo,
                change: isFixedRange ? $helpers.changedFixedRangeTo : $helpers.changedTo,
                focus: $helpers.focusedTo,
                mouseenter: $helpers.mouseenterTo,
                mouseleave: $helpers.mouseleaveTo,
              },
              "class": Object.assign({}, {
                'focused': focused === `to`
              }, {
                'to-date-input': true
              }),
            }));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((error.from && $helpers.isFromActive()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
              "attrs": __vjadeStringifyAttrsIfObj({
                type: `error`,
                'always-show': true,
              }),
            }, [__vjadeSafeCode(error.from)]));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((error.to && $helpers.isToActive()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
              "attrs": __vjadeStringifyAttrsIfObj({
                type: `error`,
                'always-show': true,
              }),
            }, [__vjadeSafeCode(error.to)]));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'calendars': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-calendar", {
            "attrs": __vjadeStringifyAttrsIfObj($helpers.getCalendarAttrs()),
            "on": {
              draw: $helpers.propagateEvent,
              selectDate: isFixedRange ? $helpers.selectedFixedRangeDate : $helpers.selectedDate,
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "error" in locals ? locals.error : typeof error !== "undefined" ? error : undefined, "focused" in locals ? locals.focused : typeof focused !== "undefined" ? focused : undefined, "from" in locals ? locals.from : typeof from !== "undefined" ? from : undefined, "isRangePicker" in locals ? locals.isRangePicker : typeof isRangePicker !== "undefined" ? isRangePicker : undefined, "to" in locals ? locals.to : typeof to !== "undefined" ? to : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;